export enum StoreConstants {
  MAX_AGE = 25, // how many actions to keep in memory for debugging

  // character size limits for Redux data, if bigger than this then show placeholder text
  MAX_STATE_SIZE = 30000, // max characters for any state
  MAX_ACTION_SIZE = 2500, // max characters for payload
}
